import "core-js/modules/es6.array.map.js";
export default {
  type: 'noresult',
  aliases: ['noresult'],
  slices: [{
    name: 'tag_list_block',
    path: 'Global/TagListBlock.vue',
    additional: {
      query: 'categories',
      handler: function handler(arg) {
        return {
          hashes: arg.items.map(function (e) {
            return e.hash;
          })
        };
      }
    }
  }, {
    name: 'rebounds',
    path: 'Global/Rebounds.vue'
  }]
};